export default __webpack_public_path__ + "static/media/Group1540@2x.808bf26f.png";